<template>
  <div v-if="items.length" class="mention-list">
    <div class="list-group list-group-flush">
      <button
        v-for="(item, index) in items"
        :key="index"
        class="list-group-item list-group-item-action"
        :class="{ 'is-active': index === selectedIndex }"
        @click="selectItem(index)"
      >
        {{ item.hoTen }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps } from "vue";

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  command: {
    type: Function,
    required: true,
  },
});

const selectedIndex = ref(0);

watch(
  () => props.items,
  () => {
    selectedIndex.value = 0;
  }
);

const selectItem = (index) => {
  const item = props.items[index];
  if (item) {
    props.command(item);
  }
};

const onKeyDown = ({ event }) => {
  if (event.key === "ArrowUp") {
    event.preventDefault();
    selectedIndex.value =
      (selectedIndex.value + props.items.length - 1) % props.items.length;
    return true;
  }

  if (event.key === "ArrowDown") {
    event.preventDefault();
    selectedIndex.value = (selectedIndex.value + 1) % props.items.length;
    return true;
  }

  if (event.key === "Enter") {
    event.preventDefault();
    selectItem(selectedIndex.value);
    return true;
  }

  return false;
};

// Expose ra ngoài để TipTap gọi
defineExpose({
  onKeyDown,
});
</script>

<style scoped>
/* [SỬA]: Tự style, không dùng 'card' */
.mention-list {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
  overflow: hidden; /* Đảm bảo các góc tròn */
}
.list-group-item {
  border: none; /* Bỏ viền của list-group */
  padding: 0.5rem 0.75rem;
}
.list-group-item.is-active {
  background-color: #007bff;
  color: white;
}
</style>
